<template>
  <div v-if="filteredDataset.length > 0">
    <table class="table table-striped is-narrow">
      <thead>
        <tr>
          <th>{{$t('entities.roles.header_name')}}</th>
          <th>{{$t('users.roles.role')}}</th>
        </tr>
      </thead>
      <transition-group tag="tbody" name="slide-in" :style="{'--total': filteredDataset.length}">
        <tr style="height:63px" v-for="(item, index) in filteredDataset" :key="index" :style="{'--i': index}">
          <td width="25%" class="align-middlecenter-vert">
            <span class="dataset__user__name" @click="showUserDetails(item)">
              {{item.name}}
            </span>
          </td>
          <td width="70%" class="align-middle">
            <div v-if="!isEditingRole || editingRow !== index">
              <div v-if="item.roles.length > 0">
                <div v-if="item.roles.length > limitItems">
                  <va-popover
                    class="custom-tooltip-tag"
                    v-for="(item, index) in getFirstNItems(item.roles, limitItems)"
                    :key="index"
                    :message="item.description"
                    placement="top">
                    <span class="tag-role">
                      {{item.name}}
                    </span>
                  </va-popover>
                  <div @click="openAllRoles(item)" class="tag-role tag-role-clicable">
                    {{$t('users.roles.actions.show_more')}} {{item.roles.length - limitItems}}..
                  </div>
                </div>
                <div v-else>
                  <va-popover
                    class="custom-tooltip-tag"
                    v-for="(item, index) in item.roles" :key="index"
                    :message="item.description"
                    placement="top">
                  <div class="tag-role">
                    {{item.name}}
                  </div>
                </va-popover>
                </div>
              </div>
              <div v-else>
                {{ $t('users.roles.without') }}
              </div>
            </div>
          </td>
        </tr>
      </transition-group>
    </table>
  </div>
  <div v-else>
    <div v-if="this.query !== ''" class="d-flex justify-content-center pt-4">
      <b> {{$t('users.roles.no_entities_found')}} </b>
    </div>
    <div v-else class="d-flex justify-content-center pt-4">
      <b> {{$t('users.roles.no_entities')}} </b>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: {
    roles: {
      type: Array,
      required: true
    },
    query: {
      type: String,
      required: false,
      default: ''
    },
    limitItems: {
      type: Number,
      required: false,
      default: 7
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    Multiselect
  },
  data () {
    return {
      isEditingRole: false,
      editingRow: -1,
      dataset: [],
      showFullRoles: false
    }
  },
  mounted () {
    this.generateDataset()
  },
  methods: {
    showUserDetails: function (user) {
      this.$router.push({ name: 'adminusers/id', params: { id: user.id } })
    },
    closeEntitiesByRoleModal: function () {
      this.showFullRoles = false
      this.entitiesForSelectedRole = []
    },
    openAllRoles: function (entity) {
      this.isEditingRole = false
      this.showFullRoles = true
      this.$emit('showRolesForEntityModal', {
        roles: entity.roles,
        entity
      })
    },
    generateDataset: function () {
      this.dataset = []
      this.roles.filter(userRole => userRole && userRole.user)
        .forEach(userRole => {
          let index = this.dataset.findIndex(item => item.id === userRole.user.id)
          if (index === -1) {
            this.dataset.push({
              id: userRole.user.id,
              name: userRole.user.name,
              roles: [userRole.role]
            })
          } else {
            this.dataset[index].roles.push(userRole.role)
          }
        })
      this.dataset.sort((a, b) => {
        let entityNameA = a.name.toLowerCase()
        let entityNameB = b.name.toLowerCase()

        if (entityNameA < entityNameB) return -1
        if (entityNameA > entityNameB) return 1
        return 0
      })
    },
    getFirstNItems: function (arr, n) {
      return arr.slice(0, n)
    },
  },
  computed: {
    ...mapGetters([
      'services'
    ]),
    filteredDataset: function () {
      if (this.query === '') return this.dataset
      return this.dataset.filter(item => {
        return item.name.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
      })
    },
    authenticationService: function () {
      return this.services.find(service => service.url === this.$store.state.evollauth_server)
    },
    authUserRoles: function () {
      return this.authenticationService.user_roles
    },
    authRoles: function () {
      return this.authenticationService.roles
    },
    authPermissions: function () {
      return this.authenticationService.user_permissions
    },
    authRolesPermissions: function () {
      return this.authPermissions.filter(p => p.info_type === 100)
    },
    authEntities: function () {
      return this.authenticationService.entities
    },
    authEntitiesRolesPermissions: function () {
      return this.authEntities.filter(e => {
        return this.authRolesPermissions.some(p => p.entity_id === e.id || p.entity_id === null)
      })
    }
  },
  watch: {
    roles: {
      handler () {
        this.generateDataset()
      },
      deep: true
    },
    query: debounce(function () {
      this.generateDataset()
    }, 500)
  }
}
</script>

<style lang="scss">
.tag-role{
  margin-right: 10px;
  margin-bottom: 0.5rem;
  padding: 0.4em 1em;
  background: #29c4a9;
  color: white;
  border-radius: 1em;
  font-weight: 100;
  font-size: 13px;
}
</style>

<style scoped lang="scss">
.dataset__user__name:hover{
  text-decoration: underline;
  cursor: pointer;
}
</style>
